export default "mutation interviewRequest($request:InterviewRequestInput!){\n    interviewRequest(request:$request)\n}\n";